import { render, staticRenderFns } from "./CmgOrderConfirmationHeader.vue?vue&type=template&id=29d1eabf&scoped=true&lang=pug&"
import script from "./cmg-order-confirmation-header.ts?vue&type=script&lang=ts&"
export * from "./cmg-order-confirmation-header.ts?vue&type=script&lang=ts&"
import style0 from "./CmgOrderConfirmationHeader.vue?vue&type=style&index=0&id=29d1eabf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d1eabf",
  null
  
)

export default component.exports